module.exports = {
  INTEREST_GROUPS_PROFILE_PREFIX: 'interestGroups',
  NEUTRAL_SCORE: 0.0,
  MAX_EVENTS: __ADA_GAUGE_MAX_EVENTS__,
  MAX_TAG_LENGTH: __ADA_GAUGE_MAX_TAG_LENGTH__,
};

